<div class="stepper-action-bar" [class]="'layout-' + layout()" [style.gap.rem]="gap()" [class.show-divider]="showDivider()">
  <!-- Start Layout: Placeholder + Next Button (50/50) -->
  <ng-container *ngIf="layout() === 'start'">
    <div class="button-placeholder"></div>
    <htx-button
      variant="primary"
      icon="arrow_forward"
      iconPosition="end"
      [disabled]="nextDisabled()"
      [fullWidth]="true"
      (buttonClick)="onNext()">
      {{ nextLabel() }}
    </htx-button>
  </ng-container>

  <!-- Between Layout: Previous + Next Button (50/50) -->
  <ng-container *ngIf="layout() === 'between'">
    <htx-button
      variant="tertiary"
      icon="arrow_back"
      [disabled]="previousDisabled()"
      [fullWidth]="true"
      (buttonClick)="onPrevious()">
      {{ previousLabel() }}
    </htx-button>
    <htx-button
      variant="primary"
      icon="arrow_forward"
      iconPosition="end"
      [disabled]="nextDisabled()"
      [fullWidth]="true"
      (buttonClick)="onNext()">
      {{ nextLabel() }}
    </htx-button>
  </ng-container>

  <!-- Last Step Layout: Single centered button -->
  <ng-container *ngIf="layout() === 'last-step'">
    <div style="width: 50%;">
      <htx-button
        variant="primary"
        icon="check"
        [disabled]="nextDisabled()"
        [fullWidth]="true"
        (buttonClick)="onLastStep()">
        {{ lastStepLabel() }}
      </htx-button>
    </div>
  </ng-container>
</div>
